<script setup lang="ts">
import type { CarModel } from '#shared/interfaces/car-model-list/model'
import { TRANSITION_SOURCE } from '#shared/constant/constant'

const { carModels } = defineProps<{
  carModels: CarModel[][]
}>()
const query = useRoute().query
const clickCount = useState<number>('click_count', () => 0)

const conditionFindFlg =
  query.transition_source === TRANSITION_SOURCE.condition_find
const displayListEmptyMessage = query.body_sub_cd
  ? `このボディタイプには現行販売車がありません。
    現行販売車の絞り込みを解除して下さい。`
  : query.brand_cd
    ? `このメーカーには現行販売車がありません。
    現行販売車の絞り込みを解除して下さい。`
    : ''

onMounted(() => {
  clickCount.value = 0
})
</script>

<template>
  <div v-if="carModels.length !== 0 || conditionFindFlg" class="model_list">
    <div
      v-for="models in carModels"
      :id="'link_' + models[0]!.group_key"
      :key="models[0]!.group_key"
      class="item-caset"
    >
      <div class="item">
        <a class="item_link">{{ models[0]!.group_key }}</a>
      </div>
      <div v-for="model in models" :key="model.car_cd" class="car-list-caset">
        <CardCarListContents :model-contents="model" />
      </div>
    </div>
  </div>
  <div v-else class="error-message">
    {{ displayListEmptyMessage }}
  </div>
</template>

<style scoped>
.car-list-caset {
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.5);
}

.model_list {
  width: 100%;
  height: 100%;
  font-size: 12px;
  background-color: #ffffff;
}

.item-caset {
  height: auto;
}

.item {
  background-color: #f7f8fa;
  height: 28px;
  position: sticky;
  top: 0;
  z-index: 1;
}
.item_link {
  font-weight: bold;
  line-height: 28px;
  padding-left: 16px;
  margin: 0;
  text-decoration: none;
  color: #333333;
}

.error-message {
  font-size: 14px;
  font-family: 'Hiragino Kaku Gothic Pro';
  margin: 15px;
  white-space: pre-line;
}
</style>
